const { REACT_APP_BUSINESS_HOST } = process.env
const Contact = () => (
  <div className="ad_managebox">
    <div className="myinfo_cardinfo nodata_info">
      <p className="txt_nodata fw_bold">
        계정정보는 카카오 비즈니스에서 조회 및 수정할 수 있습니다.
      </p>
      <a
        href={`${REACT_APP_BUSINESS_HOST}/my-info/`}
        className="btn_gb gm_bl"
        target="_blank"
        rel="noopener noreferrer">
        <span className="inner_g">카카오 비즈니스로 이동</span>
      </a>
    </div>
  </div>
)

export default Contact
